// extracted by mini-css-extract-plugin
export default {"cls1":"U12_NTfk0164tKtD8KWZ","cls2":"RwxW4O1nYmDQehCUgpsd U12_NTfk0164tKtD8KWZ"};